<template>
  <b-table
    show-empty
    responsive
    striped
    small
    class="bordered"
    :empty-text="$t('Nenhuma loja com entrega automática ou vendas no período.')"
    :fields="fields"
    :items="stores"
    primary-key="storeId"
    :tbody-tr-class="rowClass"
  >
    <template #cell(name)="{ item }">
      <b-link
        :id="`auto-delivery-monitor_store-${item.storeId}`"
        :title="$t('Filtrar o painel por esta loja')"
        @click="$emit('select-store', item.storeId)"
      >
        {{ item.name || `#${item.storeId}` }}
      </b-link>
    </template>
    <template #cell(configuration)="{ item }">
      <b-badge
        :variant="item.autoDeliveryEnabled ? 'success' : 'secondary'"
        class="mr-25"
      >
        {{ item.autoDeliveryEnabled ? $t('Automático ligado') : $t('Automático desligado') }}
      </b-badge>
      <b-badge
        :variant="item.motoboyEnabled ? 'light-primary' : 'secondary'"
        class="mr-25"
      >
        {{ item.motoboyEnabled ? $t('Motoboys ligado') : $t('Motoboys desligado') }}
      </b-badge>
      <b-badge :variant="hasSupplierGap(item) ? 'danger' : 'light-primary'">
        {{ item.activeDeliverySuppliers }} {{ $t('fornecedor(es) ativo(s)') }}
      </b-badge>
    </template>
    <template #cell(salesWithAlerts)="{ item }">
      <b-badge :variant="item.salesWithAlerts ? 'danger' : 'light-success'">
        {{ item.salesWithAlerts }}
      </b-badge>
    </template>
  </b-table>
</template>

<script>
import { BBadge, BLink, BTable } from 'bootstrap-vue'

export default {
  name: 'MonitorStoresTable',

  components: { BBadge, BLink, BTable },

  props: {
    stores: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    fields() {
      return [
        { key: 'name', label: this.$t('Loja') },
        { key: 'configuration', label: this.$t('Configuração') },
        { key: 'total', label: this.$t('No pipeline') },
        { key: 'acceptedBySupplier', label: this.$t('Aceitas') },
        { key: 'manualHandling', label: this.$t('Manuais') },
        { key: 'failed', label: this.$t('Falhas') },
        { key: 'salesWithAlerts', label: this.$t('Com alerta') },
      ]
    },
  },

  methods: {
    // Automático ligado sem fornecedor ativo leva tudo a tratativa manual.
    hasSupplierGap(store) {
      return store.autoDeliveryEnabled && !store.activeDeliverySuppliers
    },
    rowClass(store) {
      return store && this.hasSupplierGap(store) ? 'table-warning' : ''
    },
  },
}
</script>
